import app      from '../firebase';
import Bubbles  from '../components/conversations/bubbles';
import Sender   from '../components/conversations/sender';

import {
    getFirestore,
    doc,
    collection,
    getDocs,
    getDoc,
    query,
    where,
} from 'firebase/firestore';

import { useState, useEffect } from 'react';

import logo from '../media/homemoto.png';

export default function Conversations() {

    const [profile, setProfile]             = useState();
    const [seller, setSeller]               = useState();
    const [messages, setMessages]           = useState();
    const [conversations, setConversations] = useState();
    const [conversation, setConversation]   = useState();
    
    const getMessages = async conv => {
        let x = [];

        await getDoc(doc(getFirestore(app), 'conversations', conv[0]))
        
            .then(result => {
                result.data().messages.forEach(i => x.push(i))
            });
        
        setMessages(x);
        setConversation(conv[0]);

        if (conv[1].entity1.id !== localStorage.getItem('userId')) setSeller(conv[1].entity1);
        else setSeller(conv[1].entity2);
        
    }

    const getConversations = async () => {

        let x = [];

        await getDocs(query(collection(getFirestore(app), 'conversations'), where('entity1.id', '==', localStorage.getItem('userId')))).then(results => results.forEach(i => x.push([i.id, i.data()])));
        await getDocs(query(collection(getFirestore(app), 'conversations'), where('entity2.id', '==', localStorage.getItem('userId')))).then(results => results.forEach(i => x.push([i.id, i.data()])));

        setConversations(x);

        return;
    }

    const getProfile = async () => {

        if (!localStorage.getItem('userId')) {
            return window.location.replace('/');
        }

        await getDoc(doc(getFirestore(app), 'users', localStorage.getItem('userId')))
        
            .then(result => {
                setProfile([result.id, result.data()]);
            });
        
        return;
    }

    useEffect(() => {
        getProfile();
        getConversations();
    }, []);

    return(
        <>
            <div className="container-fluid bg-light p-4">

                <div className="row">

                    <div className="col-lg-3">
                        {
                            conversations && conversations.length > 0 ?
                            
                                conversations.map(i => (
                                    <div role="button" className="d-flex align-items-center mb-2" onClick={() => getMessages(i)}>
                                        <div>
                                            <img
                                                src={logo}
                                                className="img-fluid shadow rounded-circle me-3"
                                                style={{ width: 56 }}
                                                alt=""
                                            />
                                        </div>
                                        
                                        <div>
                                            <span className="d-block fw-bold">
                                                { profile && profile[0] !== i[1].entity1.id ? i[1].entity1.name : i[1].entity2.name }
                                            </span>
                                            {/* <small className="text-muted">{i[1].messages[i[1].messages.length - 1].message}</small> */}
                                        </div>
                                    </div>
                                ))
                                :
                                <h4>Empty Inbox</h4>
                        }
                    </div>

                    <div className="col-lg-9">
                        <Bubbles data={{ messages }} />
                        <Sender  data={{ messages, conversation, profile, seller }} />
                    </div>
                </div>
            </div>
        </>
    )
}